import {
  AnalysesTypes,
  AnalysesTypesLowercase,
} from '../interfaces/analyses.types';

export function resolveTypePath(
  type: AnalysesTypes | string
): AnalysesTypesLowercase | string {
  switch (type) {
    case AnalysesTypes.Measurements:
    case AnalysesTypes.MeasurementsSimple:
    case AnalysesTypesLowercase.Measurements:
    case 'MeasurementValueAnalysis':
      return AnalysesTypesLowercase.Measurements;
    case AnalysesTypes.Blood:
    case AnalysesTypes.BloodSimple:
    case AnalysesTypesLowercase.Blood:
    case 'BloodAnalysis':
      return AnalysesTypesLowercase.Blood;
    case AnalysesTypes.Questionnaire:
    case AnalysesTypes.Habits:
      return AnalysesTypesLowercase.Habits;
    case AnalysesTypes.DNA:
      return AnalysesTypesLowercase.DNA;
    case AnalysesTypes.PRS:
      return AnalysesTypesLowercase.PRS;
    case AnalysesTypes.NIPT:
      return AnalysesTypesLowercase.NIPT;
    default:
      return type;
  }
}
